import styled, { css } from 'styled-components'
interface TabProps {
  preference?: 'text' | 'video' | 'questions' | 'document'
}

interface FontSizeProps {
  fontSize?: number
}

interface ExcerptProps {
  isDarkMode: boolean
}

export const Container = styled.div<TabProps>`
  width: 100%;
  background: ${(props) =>
    props.preference !== 'video' ? `rgb(${props.theme.excerpt.high})` : '#010101'};
  border-radius: 0.5rem;
  margin: -70px auto 0;

  & > h2 {
    padding: 1rem 1.5rem 2rem;
  }

  @media (min-width: 800px) {
    max-width: 1200px;
    width: 90%;
  }
`

export const TabLesson = styled.div<TabProps>`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  background: ${(props) =>
    props.preference !== 'video' ? `rgb(${props.theme.excerpt.high})` : '#010101'};
  width: 100%;
  border-radius: 0.5rem 0.5rem 0 0;

  .optionsContent {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .timeExcerpt {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 15px;
    margin: 0 24px 0 0;
  }

  button {
    background: transparent;
    border: none;
    padding: 1rem 0.5rem 1rem 0;
    margin: 0 1rem;

    font-size: 1rem;
    line-height: 1.4375rem;
    font-weight: 500;
    color: ${(props) =>
      props.preference !== 'video' ? `rgb(${props.theme.grayscale[100]})` : '#fff'};
  }

  .text {
    font-family: Montserrat, sans-serif;
    ${(props) =>
      props.preference === 'text' &&
      css`
        border-bottom: 4px solid ${({ theme }) => `rgb(${theme.primary.base})`};
        margin-top: 4px;
        font-weight: 700;
      `}
  }

  .video {
    font-family: Montserrat, sans-serif;
    ${(props) =>
      props.preference === 'video' &&
      css`
        border-bottom: 4px solid ${({ theme }) => `rgb(${theme.primary.base})`};
        margin-top: 4px;
        font-weight: 700;
      `}
  }

  .documento {
    font-family: Montserrat, sans-serif;
  }

  .selected-document {
    border-bottom: 4px solid ${({ theme }) => `rgb(${theme.primary.base})`};
    margin-top: 4px;
    font-weight: 700;
  }
`

export const ContentWrapper = styled.div<TabProps>`
  width: 100%;
  background: ${(props) =>
    props.preference !== 'video' ? `rgb(${props.theme.excerpt.high})` : '#010101'};
  border-radius: 8px;
  margin-bottom: 2rem;

  .excerto {
    color: rgb(26, 26, 26);
  }
`

export const DangerousHeader = styled.div`
  margin-left: 0.5cm;
`

export const Dangerous = styled.div<FontSizeProps & ExcerptProps>`
  word-wrap: break-word;
  margin-left: 0.5cm;
  margin-right: 22rem;
  width: inherit;
  margin: auto;
  scroll-margin-top: 120px;

  @media only screen and (min-width: 1050px) {
    scroll-margin-top: 150px;
  }

  ${({ isDarkMode }) => isDarkMode && 'filter: invert(100%);'}

  .highlight-1,
  .highlight-2,
  .highlight-3,
  .highlight-4, img {
    filter: ${({ isDarkMode }) => isDarkMode && ' invert(100%);'};
  }

  @media only screen and (max-width: 1080px) {
    margin: 0 0.5cm;
  }

  .highlight-1,
  .highlight-2,
  .highlight-3,
  .highlight-4 {
    display: inline;
    cursor: pointer;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
  }

  .highlight-1 {
    background: #f2f200 !important;
  }

  .highlight-2 {
    background: #22f200 !important;
  }

  .highlight-3 {
    background: #00f2f2 !important;
  }

  .highlight-4 {
    background: #f201f2 !important;
  }

  .highlight-1:hover,
  .highlight-2:hover,
  .highlight-3:hover,
  .highlight-4:hover {
    display: inline;
    cursor: pointer;
  }

  div {
    padding: 0 1rem;
  }

  h2 {
    span {
      // font-size: ${(props) => `calc(${props.fontSize ?? 1} * 2rem)`};
    }
  }

  p {
    font-size: ${(props) => `calc(${props.fontSize ?? 1} * 0.95rem)`} !important;
    line-height: ${(props) => `calc(${props.fontSize ?? 1} * 1.5rem)`} !important;

    span {
      line-height: ${(props) => `calc(${props.fontSize ?? 1} * 1.2rem)`} !important;
    }
  }

  table {
    /* width: 95% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-around; */
    span {
      /* display: flex; */
      align-items: center;
      line-height: 120%;
      font-size: ${(props) => `calc(${props.fontSize ?? 1} * 1rem)`} !important;
    }
    colgroup {
      display: none;
    }
    tbody {
      tr {
        td {
          div {
            padding: 0 0.5rem;
            margin: 0;
            ol {
              li {
                display: grid;
                grid-template-columns: 4fr 2.5fr;
                grid-gap: 0.3rem;
                padding: 0;
                margin: 0;
                span {
                  display: flex;
                  flex-direction: row;
                  word-break: break-word;
                }
              }
            }
          }
        }
      }
    }
  }

  h3 {
    span {
      font-size: ${(props) => `calc(${props.fontSize ?? 1} * 0.8rem)`} !important;
    }
  }

  p {
    span {
      overflow-wrap: break-word;
      font-size: ${(props) => `calc(${props.fontSize ?? 1}* 0.9rem)`} !important;
    }
  }

  // span {
  //   img {
  //     width: 100% !important;
  //     object-fit: contain;
  //     margin: 1rem auto 1rem 0 !important;
  //   }
  // }

  @media only screen and (max-width: 1080px) {
    span {
      img {
        width: 50% !important;
        object-fit: contain;
        margin: 1rem auto 1rem 0 !important;
      }
    }
  }

  body {
    -webkit-touch-callout: none;
  }
`

export const DangerousModal = styled.div<FontSizeProps>`
  overflow: hidden;
  display: hidden; // TODO testar impressão
  @media screen {
    div {
      display: flex;
      flex-direction: column;
    }

    h2 {
      span {
        font-size: ${(props) => `calc(${props.fontSize ?? 1} * 2rem)`} !important;
      }
    }
    table {
      width: 100% !important;
      span {
        display: flex;
        align-items: center;
        line-height: 120%;
        font-size: ${(props) => `calc(${props.fontSize ?? 1} * 1rem)`} !important;
      }

      tbody {
        tr {
          td {
            div {
              padding: 0 0.5rem;
              margin: 0;
              ol {
                li {
                  word-break: break-all;
                  display: grid;
                  grid-template-columns: 4fr 2.5fr;
                  grid-gap: 0.3rem;
                  padding: 0;
                  margin: 0;
                  span {
                    display: flex;
                    flex-direction: row;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  span {
    img {
      width: 75% !important;
      object-fit: contain;
      margin: 1rem 1rem 1rem 0 !important;
    }
  }
`

export const PdfCover = styled.div``

export const Summary = styled.div`
  width: 90vw;
  height: 85vh;
  display: flex;
  flex-direction: column;
  margin: 1cm;
  margin-top: -2cm;
  table {
    h1 {
      color: #b15306;
      text-align: center;
    }
    p {
      font-weight: bold;
      line-height: 50%;
    }
  }
  @media screen {
    table {
      display: none;
    }
  }
`

export const PrintArea = styled.div`
  background: #fff;

  @media screen {
    table {
      display: none;
    }
    .content {
      max-height: 65vh;
      overflow: auto;
      .cover {
        display: none;
      }
    }
  }

  @media print {
    .printer-table {
      page-break-before: auto;
      page-break-after: auto;
      page-break-inside: auto;
      thead {
        hr {
          border: #c6c6c6 solid 0.3px;
          opacity: 40%;
          margin: 0 0.6cm 0 0.6cm;
        }
      }
      thead,
      tfoot {
        position: static;
        z-index: 1;
      }
      .content {
        height: 90%;
        width: 96%;
        margin: 2rem 0.5rem 5rem 0.5rem;
        display: flex;
        flex-direction: column;
        text-align: justify;
        white-space: pre-wrap;
      }
      #excerto {
        height: 80%;
        padding-left: 1rem;
      }
      img {
        margin: 0cm 2cm 0cm 0cm;
      }
    }
    .excerto .custom-table {
      background: #fff;
      position: relative;
      z-index: 9;
      max-width: 100%;
      box-sizing: border-box;
    }
  }
`

export const FinishButton = styled.button`
  margin: 1rem auto 4rem;
  border: 1px solid ${({ theme }) => `rgb(${theme.primary.base})`};
  color: ${({ theme }) => `rgb(${theme.primary.base})`};
  border-radius: 0.5rem;
  padding: 1rem 2rem;
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: bolder;
  background: none;

  &:disabled {
    color: #ffac0d;
    border-color: #ffac0d;
    cursor: not-allowed;
  }
`

export const DownloadExcerpt = styled.button`
  border: 1px solid ${({ theme }) => `rgb(${theme.primary.base})`};
  padding: 0.5rem 0;
  width: 140px;
  margin: 1rem 1rem 1rem auto;
  border-radius: 0.5rem;
  background: transparent;
  color: ${({ theme }) => `rgb(${theme.primary.base})`};
  font-weight: 700;
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  h3 {
    font-size: 1rem;
    width: 100%;
  }

  div {
    width: 100%;
    justify-content: flex-end;
  }

  button {
    border: 1px solid ${({ theme }) => `rgb(${theme.primary.base})`};
    background: transparent;
    color: ${({ theme }) => `rgb(${theme.primary.base})`};
    font-weight: 700;
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    margin-left: 1rem;

    svg {
      margin: -10px auto -5px;
    }
  }
`

export const NoContentWrapper = styled.div`
  padding: 1rem;
  border-radius: 0.5rem;

  h2 {
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    font-size: 1.625rem;
    font-weight: 700;
    line-height: 2rem;
    margin-bottom: 3rem;
  }

  p {
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.825rem;
    margin: 1.5rem 0;
  }
`

export const DocumentWrapper = styled.div`
  padding: 1rem 0rem;
  overflow-x: auto;
  scrollbar-width: thin;
  background-color: ${({ theme }) => (theme.isDark ? '#555' : '#ddd')};
  section {
    width: 90%;
    max-width: 1110px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
  }
`

export const DocumentHeaderWrapper = styled.div`
  padding: 1rem;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.8rem;
  flex-direction: column;

  @media only screen and (min-width: 800px) {
    flex-direction: row;
    flex-flow: wrap;
  }

  h2 {
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    font-size: 1.625rem;
    font-weight: 700;
    line-height: 2rem;
    margin-bottom: 1rem;
  }

  .pdf-viewer-control {
    display: flex;

    > div {
      display: flex;
      align-items: center;
      gap: 0.4rem;
      @media only screen and (min-width: 700px) {
        gap: 0.8rem;
      }
    }

    .navigation {
      border-right: 1px solid ${({ theme }) => (theme.isDark ? '#555' : '#808080')};
      margin-right: 12px;
      padding-right: 12px;
      text-wrap: nowrap;

      div {
        gap: 1rem;
      }

      .mobile-hide {
        display: none;
        @media only screen and (min-width: 800px) {
          display: flex;
        }
      }

      .mobile-show {
        display: flex;
        @media only screen and (min-width: 800px) {
          display: none;
        }
      }
    }

    .scale {
      border-right: 1px solid ${({ theme }) => (theme.isDark ? '#555' : '#808080')};
      margin-right: 12px;
      padding-right: 12px;
    }
  }

  .arrow-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background-color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#fff')};
    border: 1px ${({ theme }) => (theme.isDark ? '#BABABA' : '#808080')} solid;
    color: ${({ theme }) => (theme.isDark ? '#fff' : '#5e6871')};

    padding: 6px;
    @media only screen and (min-width: 1000px) {
      padding: 12px;
    }

    .icon {
      width: 16px;
      height: 16px;
    }
  }

  .arrow-button.disabled {
    cursor: default;
    color: ${({ theme }) => (theme.isDark ? '#5e6871' : '#ddd')};
    border-color: ${({ theme }) => (theme.isDark ? '#5e6871' : '#ddd')};
  }
`

export const Selects = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  .text-dropdown {
    .text-dropdown--button-area {
      padding: 10px;
    }
  }
`
